import Api from '@/api/Api';

class ThinkificAuthenticationApi extends Api {
  constructor() {
    super('thinkific/authentication', 'Thinkific Authentication');
  }
}
const thinkificAuthenticationApi = new ThinkificAuthenticationApi();
export default thinkificAuthenticationApi;
